import PropTypes from 'prop-types';
import { Typography, Divider } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useParams, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import FacilityForm from './FacilityForm';
import PortfolioForm from './PortfolioForm';

InitialDueDiligenceForm.propTypes = {
  portfolio: PropTypes.object,
};

export default function InitialDueDiligenceForm({ portfolio }) {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const facilityId = searchParams.get('facilityId');
  const userPermissions = useSelector((state) => state.transitions?.data?.userPermissions);
  const { watch } = useFormContext();

  const permissions = Object.fromEntries(
    Object.values(userPermissions?.[id]?.[facilityId]?.initialDueDiligencePermissions || {}).map((x) => [
      x.formQuestionId,
      x.isEditable,
    ])
  );

  const portfolioName = watch('portfolioName');

  return (
    <>
      <Typography sx={{ mb: 1 }} variant="h6" color="info.main">
        {portfolioName || 'New Portfolio'}
      </Typography>
      <PortfolioForm permissions={permissions} isAdmin={portfolio?.isAdmin} />
      <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
      <FacilityForm permissions={permissions} isAdmin={portfolio?.isAdmin} />
    </>
  );
}
